import {Course} from "../types/courseTypes";

/**
 * Util functions for converting date numbers into english words were generated with ChatGBT.
 * I do not claim this as my own work
 */
const formatDate = (dateString: string | null) => {
    if (dateString == null) {
        return;
    }

    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const date = new Date(dateString);
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    const formattedDay = addOrdinalIndicator(day);
    const formattedMonth = months[monthIndex];

    return `${formattedDay} ${formattedMonth} ${year}`;
};

const formatDateOrder = (dateString: string | Date) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure two digits for month
    const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits for day
    return `${year}-${month}-${day}`; // Return formatted date in YYYY-MM-DD format
};


const addOrdinalIndicator = (day: number) => {
    if (day >= 11 && day <= 13) {
        return `${day}th`;
    } else {
        const lastDigit = day % 10;
        let suffix = '';
        switch (lastDigit) {
            case 1:
                suffix = 'st';
                break;
            case 2:
                suffix = 'nd';
                break;
            case 3:
                suffix = 'rd';
                break;
            default:
                suffix = 'th';
                break;
        }
        return `${day}${suffix}`;
    }
};

const formatTime = (minutes: number): string => {
    if(minutes===0){
        return '0s';
    }
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;


    if (hours > 0 && remainingMinutes > 0) {
        return `${hours}h ${remainingMinutes}m`;
    } else if (hours > 0) {
        return `${hours}h`;
    } else {
        return `${remainingMinutes}m`;
    }
};

export const groupByDate = (convs: Course[]): Record<string, Course[]> => {
    const today = new Date('2025-05-28T13:53:00+12:00'); // Current NZST
    const groups: Record<string, Course[]> = {
        Today: [],
        Yesterday: [],
        'Last 7 Days': [],
        Month: [],
    };

    convs.forEach((conv) => {
        const convDate = new Date(conv.createdAt);
        const diffMs = today.getTime() - convDate.getTime();
        const diffDays = diffMs / (1000 * 60 * 60 * 24);

        if (diffDays <= 1 && convDate.toDateString() === today.toDateString()) {
            groups.Today.push(conv);
        } else if (diffDays <= 2 && convDate.toDateString() === new Date(today.getTime() - 24 * 60 * 60 * 1000).toDateString()) {
            groups.Yesterday.push(conv);
        } else if (diffDays <= 7) {
            groups['Last 7 Days'].push(conv);
        } else if (diffDays <= 30) {
            groups.Month.push(conv);
        }
    });

    return groups;
};

export {formatDate, formatDateOrder, formatTime}
